<script setup lang="ts"></script>

<template>
  <icon name="lucide:circle-plus" />
</template>

<style scoped></style>
